// src/utils/request.js
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { removeToken,getToken } from '@/utils/auth' // 如果有认证系统
//import baseConfig from '@/public/config.json'
import router from '@/router' // 直接导入路由实例
import i18n from '@/i18n' // 直接导入i18n实例
import { getConfig } from '@/utils/configTool';

// 创建axios实例
/*const service = axios.create({  
  baseURL:  baseConfig.apiBaseUrl, 
  timeout: 120000 // 请求超时时间
})*/

// 1. 先创建axios实例（暂不设置baseURL，或先设默认值）
const service = axios.create({  
  baseURL: '', // 先留空，后续动态赋值
  // 可选：设置默认baseURL，防止配置加载前请求报错
  // baseURL: 'https://default-api.com', 
  timeout: 120000 // 请求超时时间
})

// 2. 异步加载配置并动态设置baseURL
async function setAxiosBaseUrl() {
  try {
    // 请求public目录下的config.json（根路径直接访问，已迁移配置文件到public）
    //const configRes = await axios.get('/config.json');
    //const baseConfig = configRes.data;

    const baseConfig =await getConfig();    
    // 动态设置axios实例的baseURL
    service.defaults.baseURL = baseConfig.apiBaseUrl;
    //console.log('axios baseURL 设置成功：', baseConfig.apiBaseUrl);
  } catch (error) {
    console.error('加载配置文件失败,无法设置baseURL:', error);
    ElMessage.error(i18n.t('config.load.fail')); // 提示配置加载失败
    // 可选：配置加载失败时，设置兜底默认地址
    service.defaults.baseURL = 'http://127.0.0.1:5213';
  }
}

// 3. 立即执行配置加载函数，初始化baseURL
setAxiosBaseUrl();

// src/utils/request.js
service.interceptors.request.use(
  (config) => {  // 确保这里使用箭头函数保留this
    config = config || {};  // 防止config未定义
    config.headers = config.headers || {};  // 初始化headers
    
    // 强制设置Content-Type
    //config.headers['Content-Type'] = 'application/json';
    // 只有当不是 multipart/form-data 时才设置默认 Content-Type
    if (!config.headers['Content-Type'] && 
        !(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    // 添加token（标准写法）
    const token = getToken();
    if (token) {      
      // 如果后端必须用accessToken：
      config.headers['accessToken'] = token; 
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
 

  // 单独封装Blob错误处理
function parseBlobError(error) {
  return new Promise((_, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      try {
        const errData = JSON.parse(reader.result)
        error.message = errData.message || 'Export failed'
      } catch {
        error.message = 'Export failed: Invalid incorrect format'
      }
      reject(error)
    }
    reader.readAsText(error.response.data)
  })
}

// 处理401未授权

async function handleUnauthorized(error) {
  // 1. 清除认证信息
  await removeToken();

  // 2. 获取当前路径（兼容多种场景）
  const getCurrentPath = () => {
    try {
      // Vue Router 4+
      if (router?.currentRoute?.value) {
        return router.currentRoute.value.fullPath;
      }
      // Vue Router 3
      if (router?.currentRoute) {
        return router.currentRoute.fullPath;
      }
      // 无路由实例时回退
      return window.location.pathname + window.location.search;
    } catch (e) {
      return '/';
    }
  };

  // 3. 避免重复跳转
  if (!window.location.pathname.includes('/UserLogin')) {
    const redirect = encodeURIComponent(getCurrentPath());
    
    try {
      // 优先使用路由跳转
      await router.push(`/UserLogin?redirect=${redirect}`);
    } catch (e) {
      console.error('路由跳转失败,使用location跳转:', e);
      // 兜底方案：强制页面刷新
      window.location.href = `/UserLogin?redirect=${redirect}`;
    }
  }

  // 4. 统一错误处理
  const message = error.response?.data?.message ||   i18n.global.t('message.request.tokenExpired');
  return Promise.reject(new Error(message));
}


// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果是文件下载，直接返回整个response
    if (response.config.responseType === 'blob') {
      return response
    }
    
    const res = response.data        
        // 优化后的401判断
    if (typeof res?.code === 'number' && res.code === 401) {
      // 避免重复跳转
       return handleUnauthorized(null);
    }

    return response.status === 200 ? res : Promise.reject(new Error(response.statusText || 'Error'))
  },
   async  error => {    

     // 处理Blob错误
    if (error.response?.config?.responseType === 'blob' && error.response.data instanceof Blob) {
      return parseBlobError(error)
    }

   
           // Token失效处理
    if (error.response?.status === 401) {
      return handleUnauthorized(error);
    }
    
    
    ElMessage.error(error.message)
    return Promise.reject(error)
  }
)
export default service